import MyNFTsTemp from "../templates/NFTS/MyNFTemp";


const MyNFT = () => <MyNFTsTemp />;

export default MyNFT;